/* DRINK MILK: size advice, shared by the homepage calculator and the product page.
   Heights come from the shop's own size table. */
(function () {
  const SIZES = [
    { size: '1T', min: 80, max: 88 },
    { size: '2T', min: 88, max: 95 },
    { size: '3T', min: 95, max: 102 },
    { size: '4T', min: 102, max: 110 },
    { size: '5T', min: 110, max: 118 },
  ];
  // Starting height for each age, inside the size the table gives that age (1T for age 1, 2T for 2 … 5T for 5 and 6)
  const TYPICAL_HEIGHT = { 1: 83, 2: 91, 3: 98, 4: 106, 5: 113, 6: 116 };

  // Clothes are cut oversized already, so the size follows the child's height as is
  function recommend(height) {
    let i = SIZES.findIndex((s) => height < s.max);
    if (i === -1) i = SIZES.length - 1;
    const fit = SIZES[i];
    const lo = fit.min;
    const mid = (lo + fit.max) / 2;
    const confidence = Math.round(96 - Math.min(Math.abs(height - mid) / (fit.max - lo), 1) * 24);
    return { fit, lo, confidence, maxedOut: height >= SIZES[SIZES.length - 1].max };
  }

  // The size found by the calculator is remembered, so every page can point it out
  const SIZE_KEY = 'dm-fit-size';
  function savedSize() {
    try { return localStorage.getItem(SIZE_KEY); } catch { return null; }
  }
  function saveSize(size) {
    try { localStorage.setItem(SIZE_KEY, size); } catch { /* storage blocked: the page still works */ }
  }

  // Heights are kept in cm; shoppers can read them in inches
  const UNIT_KEY = 'dm-fit-unit';
  function unit() {
    try { return localStorage.getItem(UNIT_KEY) || (/^en-US/i.test(navigator.language) ? 'in' : 'cm'); } catch { return 'cm'; }
  }
  function setUnit(u) {
    try { localStorage.setItem(UNIT_KEY, u); } catch { /* storage blocked */ }
  }
  const toIn = (cm) => Math.round((cm / 2.54) * 2) / 2;
  // "98 cm" or "38.5 in"
  const height = (cm, u = unit()) => (u === 'in' ? `${toIn(cm)} in` : `${cm} cm`);
  const range = (lo, hi, u = unit()) => (u === 'in' ? `${toIn(lo)}–${toIn(hi)} in` : `${lo}–${hi} cm`);

  // Wires a cm/in switch: buttons with data-unit inside `root`; onChange repaints the numbers
  function bindUnits(root, onChange) {
    const btns = [...root.querySelectorAll('[data-unit]')];
    const paint = () => btns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.unit === unit())));
    btns.forEach((b) => b.addEventListener('click', () => { setUnit(b.dataset.unit); paint(); onChange(); }));
    paint();
  }

  window.DMFit = { SIZES, TYPICAL_HEIGHT, recommend, savedSize, saveSize, unit, height, range, bindUnits };
})();
